import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from "classnames";
import { withRouter } from 'react-router-dom';
import { AppBar, Toolbar, Hidden, Button, Grid, Paper, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import Typography from '../components/CustomTypo'
import { withTranslation } from 'react-i18next'
import { isRetina } from '../utils/util';
import { paths, portalCfg } from '../../portal.router.config'
import { portal_config, custom_assets, domainName } from '../../portal.config'
import { getAppCfg, getData, getLanguage, saveDataIntoAsyncStore } from '../utils/common';
import i18n from '../translations/i18n'
import { creatives_usage_types, dataUtil, usage_type } from '../wsclient/crmservices/dataUtil';
import CustomTypo from '../components/CustomTypo';
var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.background ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";

const icon = path + "/images/icon.png";
const LocalStyles = theme => ({
    root: {
        minHeight: '100vh',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: portal_config[domainName].landingPageBackgroundColor && portal_config[domainName].landingPageBackgroundColor.color ? portal_config[domainName].landingPageBackgroundColor.color : theme.palette.background.landingPage
    },
    logo_container: {
        // marginTop:theme.spacing(10),
        // marginBottom:theme.spacing(10),
        height: 120,
        position: 'relative'
    },
    logo_img: {
        width: 100,
        height: 100,
        borderRadius: 100,
        objectFit: 'contain',
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        padding: theme.spacing(1),
    },
    logo_img_square: {
        objectFit: 'contain',
        padding: theme.spacing(5),
    },
    img: {
        width: '100%',
        height: '100%',
    },
    leftPanel: {
        justifyContent: 'center',
        display: "flex",
        alignItems: "center",
    },
    rightPanel: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(2)
        },
        minHeight: '100vh',
    },
    rightPanelContainer: {
        backgroundColor: theme.palette.background.box,
        borderRadius: theme.shape.borderRadius,
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(10),
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        minHeight: '70%',
        maxHeight: '95%',
        position: 'relative'
    },

    rightPanelContent: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5),
        padding: theme.spacing(0, 0, 5, 0)
        // overflow:'scroll',
    },
    copyright: {
        bottom: theme.spacing(4),
        position: 'absolute'
    },
    form: {
        zIndex: 10,
        height: '100%'
    },
    language: {
        height: theme.spacing(8),
        width: theme.spacing(25),
        position: 'absolute',
        top: 0,
        right: 0,
        backgroundColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(10),
        // border: '1px solid',
        // borderColor: theme.palette.border.secondary,
        marginTop: theme.spacing(2),
        cursor: 'pointer'
    },
    switch: {
        height: theme.spacing(6),
        width: theme.spacing(6),
        borderRadius: theme.spacing(4),
        backgroundColor: theme.palette.button.landing_page.backgroundColor,
    },
    switch_main: {
        height: theme.spacing(6),
        width: theme.spacing(6),
        borderRadius: theme.spacing(4),
        backgroundColor: theme.palette.primary.main,
    },
    switch_primary: {
        height: theme.spacing(6),
        width: theme.spacing(6),
        borderRadius: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
    },
});

function PublicPage(props) {

    const [currentLanguge, setCurrentLanguage] = useState(getLanguage("LANGUAGE"));
    const [imageSources, setImageSources] = useState([]);
    const languages = getData('LANGUAGES') ? JSON.parse(getData('LANGUAGES')) : []

    useEffect(() => {
        let imageSources = createImageObject();
        setImageSources(imageSources);
    }, [])

    const createImageObject = () => {
        var app_config = getAppCfg();
        var creatives = app_config ? app_config.creatives : [];
        var imageSources = [];
        if (creatives && creatives.length > 0) {
            var image = dataUtil.getImageByUsageTypePortal(creatives, usage_type.APP_LOGO, true);
            if (image) {
                var imageObj = {
                    uri: image.url,
                    width: image.width,
                    height: image.height,
                }
                imageSources.push(imageObj);
            } else {
                var path = custom_assets[domainName] && custom_assets[domainName].customImage.logo ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
                let logoUrl = path + "/images/logo.png";
                imageSources.push({
                    uri: logoUrl,
                    width: 100,
                    height: 100,
                });
            }
        }
        return imageSources;
    }

    const createImage = (className) => {
        if (portal_config[domainName].localLogo) {
            return <img src={isRetina(path + "/images/logo.png", path + "/images/logo@2x.png")} className={className} style={portal_config[domainName].logoDimension ? { ...portal_config[domainName].logoDimension } : undefined} />
        } else {
            if (imageSources.length > 0)
                return <img src={imageSources[0].uri} className={className} style={portal_config[domainName].logoDimension ? { ...portal_config[domainName].logoDimension } : undefined} />
            else {
                return <CustomTypo variant='h1' color='primary'>{portal_config[domainName].app_name}</CustomTypo>
            }
        }
    }
    const onChangeLanguage1 = () => {
        var language = "";
        if (currentLanguge == 'EN') {
            language = "EL";
        } else {
            language = "EN";
        }
        setCurrentLanguage(language)
        saveDataIntoAsyncStore('LANGUAGE', language);
        i18n.changeLanguage(language);
    }

    const onChangeLanguage = (value) => {
        console.log("AAAAA onChangeLanguage value: ", value)
        setCurrentLanguage(value);
        saveDataIntoAsyncStore('LANGUAGE', value);
        i18n.changeLanguage(value);
    }
    const { classes, t, rightComponent, copyright } = props;
    var imgComponent = createImage(classes);

    var app_config = getAppCfg();
    var bg_creative = null;
    if (app_config && app_config.creatives) {
        let itemBg = app_config.creatives.filter(c => c.usage_type == usage_type.landing_page_bg);
        bg_creative = itemBg && itemBg.length > 0 ? itemBg[0] : null;
    }
    const bg_public = bg_creative ? bg_creative.url : null;



    var css_bgImage = {};
    if (bg_public) css_bgImage = {
        backgroundImage: 'url(' + bg_public + ')',
        background: '-webkit-image-set( url(' + bg_public + ') 1x, url(' + bg_public + ') 2x )',
        minHeight: '100vh',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    }
    console.log("AAAA languages: ", languages);
    console.log("AAAA currentLanguge: ", currentLanguge);
    console.log("AAAA getLanguage: ", getLanguage());
    return (
        <Grid container className={classes.root} style={!portal_config[domainName].landingPageBackgroundColor ? css_bgImage : null}>
            {/* <CssBaseline /> */}
            <Hidden only={['xs', 'sm', "md"]}>
                <Grid lg={5} xl={6} item className={classes.leftPanel}>
                    {portal_config[domainName].landingPageBackgroundColor && portal_config[domainName].landingPageBackgroundColor.logo ? <img src={icon} /> : null}
                </Grid>
            </Hidden>
            <Grid xs={12} sm={12} md={12} lg={7} xl={6} item container alignItems='center' className={classes.rightPanel}>
                <Grid xs={11} sm={11} md={10} lg={9} xl={8} item className={classes.rightPanelContainer} container justify='center'>
                    <Grid xs={12} md={9} item container alignItems='center' justify='center' className={classes.logo_container}>
                        {!portal_config[domainName].landingPageLogo ? <Typography variant="h1" color='primary'>{portal_config[domainName].app_name}</Typography> :
                            createImage(portal_config[domainName].logoStyle === 'square' ? classes.logo_img_square : classes.logo_img)}
                        {/* {domainName !== 'airlink' && <>
                            {currentLanguge==='EN'?<EnLanguage classes={classes} onChangeLanguage = {onChangeLanguage} from={props.from ? props.from : null}/>:<GrLanguage classes={classes} onChangeLanguage={onChangeLanguage} from={props.from ? props.from : null}/>}
                        </>} */}
                        {languages && languages.length > 0 && <Grid item className={classes.language} container alignItems='center' justify='center'>
                            <Select
                                id="select-languages"
                                disableUnderline
                                value={currentLanguge}
                                onChange={(event) => onChangeLanguage(event.target.value)}
                            >
                                {languages.map((item, index) => {
                                    return <MenuItem key={index} value={item.value}>{t(`${item.tran_label}`)}</MenuItem>
                                })}
                            </Select>
                        </Grid>}
                    </Grid>

                    <Grid xs={12} item container alignItems='center' justify='center' className={classes.rightPanelContent}>
                        <Grid xs={12} md={9} item container alignItems='center' justify='center'>
                            {rightComponent}
                        </Grid>

                    </Grid>
                    {copyright && <Typography color={domainName == 'buyway' || portal_config[domainName].publicPagePrimaryColor ? 'onPrimary' : 'primary'} className={classes.copyright}>{copyright}</Typography>}
                </Grid>
            </Grid>
        </Grid>
    );
}
function EnLanguage(props) {
    const { classes, onChangeLanguage, from } = props
    let cssSwitch = classes.switch;
    if (domainName === 'buyway') cssSwitch = classes.switch_primary;
    else if (from && from === paths.landingPage) cssSwitch = classes.switch_main;

    return (
        <Grid item className={classes.language} container alignItems='center' justify='center' onClick={() => onChangeLanguage()}>
            <Grid xs={5} item container justify='flex-start'>
                <Typography variant="body2" color={portal_config[domainName].publicPagePrimaryColor ? 'onPrimary' : 'onBox'} style={{ marginRight: '1px' }}>En</Typography>
            </Grid>
            <Grid xs={5} item container justify='flex-end'>
                <Grid item className={cssSwitch}>

                </Grid>
                {/* <USAFlagIcon/> */}
            </Grid>
        </Grid>
    )
}
function GrLanguage(props) {
    const { classes, onChangeLanguage, from } = props
    let cssSwitch = classes.switch;
    if (domainName === 'buyway') cssSwitch = classes.switch_primary;
    else if (from && from === paths.landingPage) cssSwitch = classes.switch_main;
    return (
        <Grid item className={classes.language} container alignItems='center' justify='center' onClick={() => onChangeLanguage()}>
            <Grid xs={5} item container justify='flex-start'>
                <Grid item className={cssSwitch}>
                </Grid>
                {/* <GREFlagIcon/> */}
            </Grid>
            <Grid xs={5} item container justify='flex-end' >
                <Typography variant="body2" color={portal_config[domainName].publicPagePrimaryColor ? 'onPrimary' : 'onBox'} style={{ marginRight: '1px' }}>Gr</Typography>
            </Grid>

        </Grid>
    )
}
export default withRouter(withStyles(LocalStyles)(withTranslation()(PublicPage)));